// Module
var code = "<select class=\"form-control\" ng-model=\"vm.value\" ng-options=\"option.id as (option | translateProperty:'name') for option in vm.options track by option.id\" ng-required=\"{{ vm.required ? 'true' : '' }}\"></select> ";
// Exports
module.exports = code;